// Reference: https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/readyState
export default {
   AUDIO_READY_STATE_HAVE_NOTHING: 0,
   AUDIO_READY_STATE_HAVE_METADATA: 1,
   AUDIO_READY_STATE_HAVE_CURRENT_DATA: 2,
   AUDIO_READY_STATE_HAVE_FUTURE_DATA: 3,
   AUDIO_READY_STATE_HAVE_ENOUGH_DATA: 4,
}
